Namespace 'Customer.Ticket.SkyChile'

class Customer.Ticket.SkyChile.ExternalTicketView extends Backbone.View
  template: JST['backbone/templates/customer/ticket/sky_chile/external_ticket']

  initialize: ({externalTicket}) ->
    @externalTicket = externalTicket

  render: ->
    @$el.html(@template({
      name: @externalTicket.get('additionalInfo').name
      documentType: @externalTicket.get('additionalInfo').documentType
      documentId: @externalTicket.get('additionalInfo').documentId
      ticketId: @externalTicket.get('ticketId')
      pnr: @externalTicket.get('additionalInfo').pnr
      relationship: @externalTicket.get('additionalInfo').relationship
      status: @externalTicket.get('status')
      nps: @externalTicket.get('additionalInfo').nps
      createdAt: @externalTicket.get('createdAt')
      categorization: @externalTicket.get('categorization')
      keepconTicket: @keepconTicket()
      icon: [
        window.image_path("sky_chile_icon/sky_chile_icon.png"),
        window.image_path("sky_chile_icon/sky_chile_icon@2x.png"),
        window.image_path("sky_chile_icon/sky_chile_icon@3x.png"),
      ]
    }))
    @renderAssignation() if @keepconTicket()
    @$el.find('.open-ticket-button').on('click', @onClickOpen) if @keepconTicket()
    @$el.find('.opening-ticket-button').hide()
    @setNpsColor()
    @

  keepconTicket: ->
    @externalTicket.get('associatedCEMTicket')

  keepconTicketId: ->
    @keepconTicket().get('id')

  onClickOpen: =>
    Backbone.trigger 'ui:blocked'
    if @keepconTicket().get('loaded')
      @keepconTicket().open()
    else
      @$el.find('.open-ticket-button').hide()
      @$el.find('.opening-ticket-button').show()

      @keepconTicket().fetch({
        silent: true
        global: false
        data: {page: 1}
        success: (ticket) ->
          ticket.open()
      }).complete( =>
        @$el.find('.open-ticket-button').show()
        @$el.find('.opening-ticket-button').hide()
        Backbone.trigger 'ui:unblocked'
      )

  renderAssignation: ->
    ticketStatusView = new Customer.Ticket.TicketStatusView(ticket: @keepconTicket())
    @$el.find('.status-section').append(ticketStatusView.render().el)

  setNpsColor: ->
    nps = @externalTicket.get('additionalInfo').nps
    switch
      when nps < 4 then @$el.find('.nps').addClass('red')
      when nps < 8 then @$el.find('.nps').addClass('yellow')
      when nps <= 10 then @$el.find('.nps').addClass('green')
